<template>
    <div class="plan-task-crud">
      <template v-if="urlId || action">
            <PlanUrlAddTaskModal
                v-if="action === taskActions.add"
                :hide-header-btn="hideHeaderBtn"
                :iframe-view="iframeView"
                @close="$emit('close'); $plan.resetPlanCRUDState(); $plan.setPlanAction(null)"
                @planTaskCreated="planTaskCreated"
            />
            <PlanUrlNewTaskModal
                v-else-if="action === taskActions.create && urlId"
                :urlId="urlId"
                :service="service"
                :hide-header-btn="hideHeaderBtn"
                :iframe-view="iframeView"
                @close="$emit('close'); $plan.resetPlanCRUDState(); $plan.setPlanAction(null)"
                @planTaskCreated="planTaskCreated"
            />

            <PlanUrlTaskModal
                v-else-if="action === taskActions.view && taskId"
                :urlTaskId="taskId"
                :service="service"
                :hide-header-btn="hideHeaderBtn"
                :iframe-view="iframeView"
                :runId="runId"
                :urlId="urlId"
                :is-access-allow="isTaskAccess"
                @close="$emit('close'); $plan.resetPlanCRUDState(); $plan.setPlanAction(null)"
                @openTasks="listPlanTask();"
                @requestError="err => requestErrorMessage = err"
            />

            <PlanUrlTaskListModal
                v-else-if="action === taskActions.list"
                :is-access-allow="isTaskAccess"
                :urlId="urlId"
                :service="service"
                :hide-header-btn="hideHeaderBtn"
                @close="$emit('close'); $plan.resetPlanCRUDState(); $plan.setPlanAction(null)"
                @requestError="err => requestErrorMessage = err"
            />
        </template>

        <ReactiveAlert
            v-if="requestErrorMessage"
            class="reactive-alert_danger"
            title="Ошибка при сохранении"
            @close="requestErrorMessage = ''"
        >
            <p v-html="requestErrorMessage"></p>
        </ReactiveAlert>
    </div>
</template>

<script>
import {mapState} from "vuex";
import { serviceVars } from "@common/utils/vars";
import { taskActionsVars } from "@common/utils/vars";
import PlanUrlTaskListModal from "@/vue/plan/url/TaskList";
import PlanUrlTaskModal from "@/vue/plan/url/Task";
import PlanUrlNewTaskModal from "@/vue/plan/url/TaskNew";
import PlanUrlAddTaskModal from "@/vue/plan/url/TaskAdd";

export default {
    name: "PlanTaskCRUD",
    props: ['hideHeaderBtn', 'iframeView'],
    created() {
        this.$store.registerModule('planUrlNew', require('@/vue/plan/store/planUrlNew').default);
        this.$store.registerModule('planUrlAdd', require('@/vue/plan/store/planUrlAdd').default);
        this.$store.registerModule('planCRUD', require('@/vue/plan/store/planCRUD').default);
        this.$store.registerModule('planUrl', require('@/vue/plan/store/planUrl').default);
        this.$store.registerModule('planUrlTask', require('@/vue/plan/store/planUrlTask').default);
        this.$store.registerModule('planUrlTaskLogs', require('@/vue/plan/store/planUrlTaskLogs').default);
        this.$store.registerModule('planObjects', require('@/vue/plan/store/planObjects').default);
    },
    components: {
        PlanUrlNewTaskModal,
        PlanUrlAddTaskModal,
        PlanUrlTaskModal,
        PlanUrlTaskListModal,
    },
    data() {
        return {
            requestErrorMessage: '',
        }
    },
    computed: {
        ...mapState({
            isTaskAccess: state => state.common.isTaskAccess,
            action: state => state.planCRUD.action,
            resultId: state => state.planCRUD.resultId,
            urlId: state => state.planCRUD.urlId,
            taskId: state => state.planCRUD.taskId,
            runId: state => state.planCRUD.runId,
            service: state => state.planCRUD.service,
        }),
        getSermService() {
            return serviceVars.serm;
        },
        taskActions() {
            return taskActionsVars;
        },
    },
    methods: {
        planTaskCreated({taskId, runId, service, urlId}) {
            this.$plan.setPlanTaskCreated(true);
            this.$plan.openPlanUrlTask(this.resultId, taskId, '', runId, service, urlId);
            this.$plan.setPlanAction('view');
        },
        listPlanTask() {
            this.$plan.openPlanUrlNewTask(this.runId, this.urlId, this.service || this.getSermService);
            this.$plan.setPlanAction('list');
        },
    },
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

@import "/resources/scss/modules/task/task-summary";
@import "/resources/scss/modules/task/task-prop";
</style>
